import { render, staticRenderFns } from "./BioCardModal.vue?vue&type=template&id=56485c25&scoped=true&"
import script from "./BioCardModal.vue?vue&type=script&lang=js&"
export * from "./BioCardModal.vue?vue&type=script&lang=js&"
import style0 from "./BioCardModal.vue?vue&type=style&index=0&id=56485c25&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56485c25",
  null
  
)

export default component.exports